<!--
 * @Author: wang peng
 * @Description: 历史订单列表  
-->
<template>
  <scroll-layout class="directConnectionPile-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button
              v-rbac="'mplatform:business:order:column'"
              type="plain"
              @click="customColumns">
              自定义列
            </ykc-button>
            <ykc-button
              v-rbac="'mplatform:business:order:export'"
              type="plain"
              @click="doExportFile">
              导出
            </ykc-button>
          </div>
        </template>
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @current-change="handlePaginationCurrentChange"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
      <!--自定义列弹窗 -->
      <ykc-operation-dialog
        title="自定义列"
        size="large"
        show-footer
        :show.sync="showDialog"
        :before-close="onCLose"
        :before-cancel="onCLose"
        :before-confirm="beforeConfirm">
        <div slot="content">
          <el-form
            size="mini"
            label-width="80px"
            ref="customForm"
            class="customForm"
            :model="customForm"
            :rules="customRules">
            <el-form-item label="列选项:" prop="checkOption">
              <ykc-checkbox
                :configSet="{
                  label: 'label',
                  value: 'value',
                }"
                :data="customData"
                :labelWidth="7"
                v-model="customForm.checkOption"
                @change="checkboxChange"></ykc-checkbox>
            </el-form-item>
          </el-form>
          <div style="margin-bottom: 10px; text-align: right">
            <ykc-button type="primary" size="mini" @click="selectAll">全选</ykc-button>
            <ykc-button
              type="primary"
              size="mini"
              @click="resetToDefault"
              style="margin-left: 10px">
              恢复默认
            </ykc-button>
          </div>
        </div>
      </ykc-operation-dialog>
    </div>
  </scroll-layout>
</template>
<script>
  import {
    code,
    getLastTime,
    localSetItem,
    localGetItem,
    sessionGetItem,
    offlineExport,
  } from '@/utils';
  import { businessPlatform, orderPage } from '@/service/apis';

  export default {
    name: 'orderDataList',
    components: {},
    inject: ['reload'],
    data() {
      return {
        showDialog: false,
        sourceChannelOptions: [], // 订单来源渠道选项，从字典获取
        searchParams: {
          orderId: null,
          userId: null,
          merchantId: null,
          merchantName: null,
          oldPlatformOrderId: null,
          orderType: null,
          tradeMode: null,
          payMethod: null,
          paymentStatus: null,
          sourceChannel: null,
          orderMethod: null,
          orderStatus: null,
          startTimeRange: [],
          endTimeRange: [],
          startTimeFrom: null,
          startTimeTo: null,
          endTimeFrom: null,
          endTimeTo: null,
        },
        stationIdData: [],
        userCompanyIdData: [], // 归属机构数据
        customForm: {
          checkOption: [0, 76, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 23],
        },
        customData: [
          {
            value: 0,
            label: '订单ID',
          },
          {
            value: 76,
            label: '关联订单号',
          },
          {
            value: 1,
            label: '用户ID',
          },
          {
            value: 2,
            label: '商户ID',
          },
          {
            value: 3,
            label: '商户名称',
          },
          {
            value: 4,
            label: '订单类型',
          },
          {
            value: 5,
            label: '订单交易模式',
          },
          {
            value: 6,
            label: '订单来源渠道',
          },
          {
            value: 7,
            label: '订单商品列表',
          },
          {
            value: 8,
            label: '开始充电时间',
          },
          {
            value: 9,
            label: '结束充电时间',
          },
          {
            value: 10,
            label: '充电时长(小时)',
          },
          {
            value: 11,
            label: '充电电量',
          },
          {
            value: 12,
            label: '电费(不含优惠)',
          },
          {
            value: 13,
            label: '服务费(不含优惠)',
          },
          {
            value: 14,
            label: '活动优惠金额',
          },
          {
            value: 15,
            label: '卡券优惠金额',
          },
          {
            value: 16,
            label: '会员权益卡优惠金额',
            minWidth: 200,
          },
          {
            value: 17,
            label: '私桩红包优惠金额',
          },
          {
            value: 18,
            label: '会员卡优惠金额',
          },
          {
            value: 19,
            label: '电费优惠金额',
          },
          {
            value: 20,
            label: '服务费优惠金额',
          },
          {
            value: 21,
            label: '优惠总金额',
          },
          {
            value: 22,
            label: '运费金额',
          },
          {
            value: 23,
            label: '订单实付总金额',
          },
          {
            value: 24,
            label: '订单金额是否给物业',
          },
          {
            value: 25,
            label: '订单支付状态',
          },
          {
            value: 26,
            label: '用户备注',
          },
          {
            value: 27,
            label: '下单方式',
          },
          {
            value: 28,
            label: '发货时间',
          },
          {
            value: 29,
            label: '完成时间',
          },
          {
            value: 30,
            label: '创建时间',
          },
          {
            value: 31,
            label: '更新时间',
          },
          {
            value: 32,
            label: '用户手机号',
          },
          {
            value: 33,
            label: '用户等级',
          },
          {
            value: 34,
            label: '用户成长值',
          },
          {
            value: 35,
            label: '支付方式',
          },
          {
            value: 36,
            label: '收款商户号',
          },
          {
            value: 37,
            label: '交易流水号',
          },
          {
            value: 38,
            label: '支付金额',
          },
          {
            value: 39,
            label: '支付状态',
          },
          {
            value: 40,
            label: '支付时间',
          },
          {
            value: 41,
            label: '退款单ID',
          },
          {
            value: 42,
            label: '申请人类型',
          },
          {
            value: 43,
            label: '申请人ID',
          },

          {
            value: 44,
            label: '退款申请备注',
          },
          {
            value: 45,
            label: '退款原因',
          },
          {
            value: 46,
            label: '退款类型',
          },
          {
            value: 47,
            label: '退款金额',
          },
          {
            value: 48,
            label: '退款状态',
          },

          {
            value: 49,
            label: '退款回执单号',
          },
          {
            value: 50,
            label: '退款失败原因',
          },

          {
            value: 51,
            label: '退款成功时间',
          },

          {
            value: 52,
            label: '审核人',
          },
          {
            value: 53,
            label: '审核备注',
          },
          {
            value: 54,
            label: '审核时间',
          },
          {
            value: 55,
            label: '退款商户名称',
          },
          {
            value: 56,
            label: '退款商户编码',
          },
          {
            value: 57,
            label: '用户账号',
          },
          {
            value: 58,
            label: '银行卡号',
          },
          {
            value: 59,
            label: '开户行',
          },
          {
            value: 60,
            label: '退款创建时间',
          },
          {
            value: 61,
            label: '退款更新时间',
          },
          {
            value: 62,
            label: '电桩ID',
          },
          {
            value: 63,
            label: '枪ID',
          },
          {
            value: 64,
            label: 'BD',
          },
          {
            value: 65,
            label: '归属商户ID',
          },
          {
            value: 66,
            label: '省',
          },
          {
            value: 67,
            label: '市',
          },
          {
            value: 68,
            label: '区',
          },

          {
            value: 69,
            label: '商品ID',
          },
          {
            value: 70,
            label: '商品名称',
          },
          {
            value: 71,
            label: '商品类型',
          },
          {
            value: 72,
            label: '商品单位',
          },
          {
            value: 73,
            label: '购买数量',
          },
          {
            value: 74,
            label: '商品单价',
          },
          {
            value: 75,
            label: '小计金额',
          },
        ],
        customRules: {
          checkOption: [{ required: true, message: '请至少选择一个列名称', trigger: 'blur' }],
        },
        tableTitle: '订单列表',
        tableData: [],
        tableOperateButtons: [], // 列表操作
        tableColumns: [
          { label: '订单ID', prop: 'id', minWidth: '200px', id: 0 },
          { label: '关联订单号', prop: 'oldPlatformOrderId', minWidth: '250px', id: 76 },
          { label: '用户ID', prop: 'userId', minWidth: '160px', id: 1 },
          { label: '商户ID', prop: 'merchantId', minWidth: '160px', id: 2 },
          {
            label: '商户名称',
            prop: 'merchantName',
            minWidth: '220px',
            id: 3,
          },
          {
            label: '订单类型',
            prop: 'orderType',
            minWidth: '200px',
            id: 4,
            scopedSlots: {
              default: ({ row }) => this.getOrderTypeText(row.orderType),
            },
          },
          {
            label: '订单交易模式',
            prop: 'tradeMode',
            minWidth: '120px',
            id: 5,
            scopedSlots: {
              default: ({ row }) => this.getTradeModeText(row.tradeMode),
            },
          },
          {
            label: '订单来源渠道',
            prop: 'sourceChannel',
            minWidth: '150px',
            id: 6,
            scopedSlots: {
              default: ({ row }) => row.sourceChannel || '--',
            },
          },
          { label: '订单商品列表', prop: 'productIds', minWidth: '150px', id: 7 },
          { label: '开始充电时间', prop: 'startTime', minWidth: '180px', id: 8 },

          { label: '结束充电时间', prop: 'endTime', minWidth: '180px', id: 9 },
          {
            label: '充电时长',
            prop: 'chargingDuration',
            minWidth: '150px',
            id: 10,
          },
          { label: '充电电量', prop: 'chargingPower', minWidth: '150px', id: 11 },
          {
            label: '电费(不含优惠)',
            prop: 'electricityFee',
            minWidth: '150px',
            id: 12,
          },
          {
            label: '服务费(不含优惠)',
            prop: 'serviceFee',
            minWidth: '150px',
            id: 13,
          },
          { label: '活动优惠金额', prop: 'activityDiscount', minWidth: '150px', id: 14 },
          { label: '卡券优惠金额', prop: 'cardCouponDiscount', minWidth: '150px', id: 15 },
          { label: '会员权益卡优惠金额', prop: 'benifitCardDiscount', minWidth: '150px', id: 16 },
          { label: '私桩红包优惠金额', prop: 'redpakDiscount', minWidth: '150px', id: 17 },
          { label: '会员卡优惠金额', prop: 'vipDiscount', minWidth: '150px', id: 18 },
          { label: '电费优惠金额', prop: 'elecDiscount', minWidth: '150px', id: 19 },
          { label: '服务费优惠金额', prop: 'serviceDiscount', minWidth: '150px', id: 20 },
          {
            label: '优惠总金额',
            prop: 'totalDiscount',
            minWidth: '150px',
            id: 21,
          },
          {
            label: '运费金额',
            prop: 'shippingFee',
            minWidth: '150px',
            id: 22,
          },
          { label: '订单实付总金额', prop: 'totalMeetAmount', minWidth: '150px', id: 23 },
          { label: '订单金额是否给物业', prop: 'amountToPropertyDesc', minWidth: '180px', id: 24 },
          {
            label: '订单支付状态',
            prop: 'paymentStatus',
            minWidth: '150px',
            id: 25,
            scopedSlots: {
              default: ({ row }) => this.getPaymentStatusText(row.paymentStatus),
            },
          },
          {
            label: '用户备注',
            prop: 'userRemark',
            minWidth: '150px',
            id: 26,
          },
          {
            label: '下单方式',
            prop: 'orderMethod',
            minWidth: '150px',
            id: 27,
            scopedSlots: {
              default: ({ row }) => this.getOrderMethodText(row.orderMethod),
            },
          },
          {
            label: '发货时间',
            prop: 'shippingTime',
            minWidth: '150px',
            id: 28,
          },
          {
            label: '完成时间',
            prop: 'completionTime',
            minWidth: '150px',
            id: 29,
          },
          {
            label: '创建时间',
            prop: 'createdTime',
            minWidth: '150px',
            id: 30,
          },
          {
            label: '更新时间',
            prop: 'modifiedTime',
            minWidth: '150px',
            id: 31,
          },
          { label: '用户手机', prop: 'userPhone', minWidth: '150px', id: 32 },
          {
            label: '用户等级',
            prop: 'userLevel',
            minWidth: '150px',
            id: 33,
            scopedSlots: {
              default: ({ row }) => this.getUserLevelText(row.userLevel),
            },
          },
          { label: '用户成长值', prop: 'userGrowthValue', minWidth: '150px', id: 34 },
          {
            label: '支付方式',
            prop: 'payMethod',
            minWidth: '150px',
            id: 35,
            scopedSlots: {
              default: ({ row }) => this.getPayMethodText(row.payMethod),
            },
          },
          { label: '收款商户号', prop: 'payMerchantId', minWidth: '150px', id: 36 },
          { label: '交易流水号', prop: 'transactionNo', minWidth: '150px', id: 37 },
          { label: '支付金额', prop: 'payAmount', minWidth: '150px', id: 38 },
          { label: '支付状态', prop: 'payStatusDesc', minWidth: '150px', id: 39 },
          { label: '支付时间', prop: 'payTime', minWidth: '150px', id: 40 },
          { label: '退款单ID', prop: 'refundId', minWidth: '150px', id: 41 },
          { label: '申请人类型', prop: 'applicantTypeDesc', minWidth: '150px', id: 42 },
          { label: '申请人ID', prop: 'applicantId', minWidth: '150px', id: 43 },
          { label: '退款申请备注', prop: 'refundRemark', minWidth: '150px', id: 44 },
          { label: '退款原因', prop: 'refundReason', minWidth: '150px', id: 45 },
          { label: '退款类型', prop: 'refundTypeDesc', minWidth: '150px', id: 46 },
          { label: '退款金额', prop: 'refundAmount', minWidth: '150px', id: 47 },
          { label: '退款状态', prop: 'refundStatusDesc', minWidth: '150px', id: 48 },
          { label: '退款回执单号', prop: 'refundReceiptNo', minWidth: '150px', id: 49 },
          { label: '退款失败原因', prop: 'refundFailReason', minWidth: '150px', id: 50 },
          { label: '退款成功时间', prop: 'refundSuccessTime', minWidth: '150px', id: 51 },
          { label: '审核人', prop: 'reviewer', minWidth: '150px', id: 52 },
          { label: '审核备注', prop: 'reviewRemark', minWidth: '150px', id: 53 },
          { label: '审核时间', prop: 'reviewTime', minWidth: '150px', id: 54 },
          { label: '退款商户名称', prop: 'refundMerchantName', minWidth: '150px', id: 55 },
          { label: '退款商户编码', prop: 'refundMerchantCode', minWidth: '150px', id: 56 },
          { label: '用户账号', prop: 'userAccount', minWidth: '150px', id: 57 },
          { label: '银行卡号', prop: 'bankCardNumber', minWidth: '150px', id: 58 },
          { label: '开户行', prop: 'bankName', minWidth: '150px', id: 59 },
          { label: '退款创建时间', prop: 'refundCreatedTime', minWidth: '150px', id: 60 },
          { label: '退款更新时间', prop: 'refundModifiedTime', minWidth: '150px', id: 61 },
          { label: '电桩ID', prop: 'pileId', minWidth: '150px', id: 62 },
          { label: '枪ID', prop: 'gunId', minWidth: '150px', id: 63 },
          { label: 'BD', prop: 'stationBd', minWidth: '150px', id: 64 },
          { label: '归属商户ID', prop: 'mchCode', minWidth: '150px', id: 65 },
          { label: '省', prop: 'provinceName', minWidth: '150px', id: 66 },
          { label: '市', prop: 'cityName', minWidth: '150px', id: 67 },
          { label: '区', prop: 'districtName', minWidth: '150px', id: 68 },
          { label: '商品ID', prop: 'productId', minWidth: '150px', id: 69 },
          { label: '商品名称', prop: 'productName', minWidth: '150px', id: 70 },
          { label: '商品类型', prop: 'productTypeDesc', minWidth: '150px', id: 71 },
          { label: '商品单位', prop: 'productUnit', minWidth: '150px', id: 72 },
          { label: '购买数量', prop: 'purchaseQuantity', minWidth: '150px', id: 73 },
          { label: '商品单价', prop: 'unitPrice', minWidth: '150px', id: 74 },
          { label: '小计金额', prop: 'subtotalAmount', minWidth: '150px', id: 75 },
        ],
        pageInfo: {
          current: 1,
          size: 10,
        },
        showDrawer: false, // 是否展示抽屉
        loading: false, // 是否展示loading
        aiData: {}, // ai分析结果
        aiTradeSeq: '', // AI弹窗充电单号
        drawerButtons: [
          {
            label: '取消',
            type: 'plain',
            enabled: () => true,
            disabled: () => false,
            handler: () => {
              this.showDrawer = false; // 隐藏抽屉
            },
          },
        ],
      };
    },
    created() {
      this.stopChargeReason = localGetItem('dictionary').stop_charge_reason || [];
      this.isProperty = JSON.parse(sessionGetItem('propertyFlag'));

      // 获取订单来源渠道字典数据
      const dictionary = localGetItem('dictionary');
      console.log('dictionary', dictionary);
      if (dictionary?.source_channel) {
        this.sourceChannelOptions = dictionary.source_channel
          .map(item => ({
            id: item.code,
            name: item.name,
            sort: item.sort,
          }))
          .sort((a, b) => a.sort - b.sort); // 按 sort 字段排序
      }
      // 页面跳转传参
      if (this.$route.query.data) {
        const query = JSON.parse(this.$route.query.data);
        console.log('query+++', query);
      }

      // 近30天初始化时间
      if (this.searchParams.recordIds && this.searchParams.recordIds.length) {
        this.searchParams.startTimeRange = [];
        this.searchParams.startTimeFrom = '';
        this.searchParams.startTimeTo = '';
      } else {
        const startDate = getLastTime('yyyy-MM-dd', 30);
        const endDate = getLastTime('yyyy-MM-dd', 0);
        this.searchParams.startTimeRange = [startDate, endDate];
        this.searchParams.startTimeFrom = startDate;
        this.searchParams.startTimeTo = endDate;
      }

      // 自定义列处理
      const customForm = localGetItem('orderDataListCustomForm');
      console.log('----', customForm);
      if (customForm) {
        this.customForm.checkOption = customForm;
        this.tableColumns = this.tableColumns.filter(item => {
          return customForm.includes(item.id);
        });
        console.log('----1', this.tableColumns);
      } else {
        // 如果没有本地存储的配置，使用初始化时设置的默认值
        this.tableColumns = this.tableColumns.filter(item => {
          return this.customForm.checkOption.includes(item.id);
        });
      }
      this.requestList();
      this.initData();
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcDatePicker',
            key: 'startTimeRange',
            label: '充电开始时间 ',
            placeholder: '请选择充电时间',
            type: 'daterange',
          },
          {
            comName: 'YkcDatePicker',
            key: 'endTimeRange',
            label: '充电结束时间 ',
            clearable: true,
            placeholder: '请选择结束充电时间',
            type: 'daterange',
          },
          {
            comName: 'YkcInput',
            key: 'orderId',
            label: '订单ID ',
            placeholder: '请输入订单ID',
          },
          {
            comName: 'YkcInput',
            key: 'oldPlatformOrderId',
            label: '关联订单号',
            placeholder: '请输入关联订单号',
          },
          {
            comName: 'YkcInput',
            key: 'userId',
            label: '下单用户ID',
            placeholder: '请输入下单用户ID',
          },
          {
            comName: 'YkcInput',
            key: 'merchantId',
            label: '商户ID',
            placeholder: '请输入商户ID',
          },
          {
            comName: 'YkcInput',
            key: 'merchantName',
            label: '商户名称',
            placeholder: '请输入商户名称',
          },
          {
            comName: 'YkcDropdown',
            key: 'orderType',
            label: '订单类型',
            placeholder: '请选择订单类型',
            data: [
              { id: 1, name: '淘淘充充电订单' },
              { id: 2, name: '益虫充电订单' },
            ],
          },
          {
            comName: 'YkcDropdown',
            key: 'tradeMode',
            label: '订单交易模式',
            placeholder: '请选择订单交易模式',
            data: [
              { id: 1, name: '自营' },
              { id: 2, name: '加盟' },
            ],
          },
          {
            comName: 'YkcDropdown',
            key: 'payMethod',
            label: '订单支付方式',
            placeholder: '请选择订单支付方式',
            data: [
              { id: 0, name: '个人' },
              { id: 1, name: '企业' },
              { id: 2, name: '微信支付分' },
              { id: 3, name: '支付宝芝麻信用' },
              { id: 4, name: '微信' },
              { id: 5, name: '支付宝' },
              { id: 6, name: '会员权益卡' },
            ],
          },
          {
            comName: 'YkcDropdown',
            key: 'paymentStatus',
            label: '订单支付状态',
            placeholder: '请选择订单支付状态',
            data: [
              { id: 1, name: '待支付' },
              { id: 2, name: '已支付' },
            ],
          },
          {
            comName: 'YkcDropdown',
            key: 'sourceChannel',
            label: '订单来源渠道',
            placeholder: '请选择订单来源渠道',
            data: this.sourceChannelOptions,
          },
          {
            comName: 'YkcDropdown',
            key: 'orderMethod',
            label: '下单方式',
            placeholder: '请选择下单方式',
            data: [
              { id: 1, name: '扫码启动' },
              { id: 3, name: '刷卡启动' },
              { id: 4, name: '即插即充' },
              { id: 5, name: '流量方' },
              { id: 6, name: '预约充电' },
              { id: 7, name: '离线卡' },
              { id: 8, name: '私桩即插即充' },
              { id: 9, name: '私桩预约充电' },
            ],
          },
        ];
      },
    },
    methods: {
      /**
       * 初始数据
       */
      initData() {
        this.tableOperateButtons = [
          {
            id: '2',
            enabled: () => code('mplatform:business:order:detail'),
            text: '详情',
            handleClick: (btn, { row }) => {
              this.$router.push({
                path: '/mplatform/businessPlatform/orderData/Detail',
                query: { orderId: row.id },
              });
            },
          },
        ];
      },
      /**
       * 导出
       */
      doExportFile() {
        offlineExport({
          downloadType: 'static_order_export',
          jsonNode: {
            ...this.searchParams,
          },
        });
      },
      /**
       * 自定义列
       * */
      customColumns() {
        this.showDialog = true;
      },
      /**
       * 组件change方法调用信息提示
       */
      checkboxChange(e) {
        this.customForm.checkOption = e;
        console.log('this.customForm+++', this.customForm);
      },
      /**
       * 全选
       */
      selectAll() {
        this.customForm.checkOption = this.customData.map(item => item.value);
      },
      /**
       * 清空
       */
      resetToDefault() {
        // 恢复到默认勾选项
        this.customForm.checkOption = [0, 76, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 23]; // 默认显示的列
      },
      /**
       *  弹窗确认
       * */
      beforeConfirm(done) {
        console.log('确认', this.customForm);
        this.$refs.customForm.validate(valid => {
          if (valid) {
            localSetItem('orderDataListCustomForm', JSON.stringify(this.customForm.checkOption));
            done();
            this.reload();
          }
        });
      },
      /**
       * 弹窗关闭
       * */
      onCLose() {
        this.showDialog = false;
        this.showRefund = false;
      },

      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        console.log('searchData++++', searchData);
        this.pageInfo.current = 1;
        Object.assign(this.searchParams, searchData);

        if (searchData.startTimeRange && searchData.startTimeRange.length > 0) {
          [this.searchParams.startTimeFrom, this.searchParams.startTimeTo] =
            searchData.startTimeRange;
        }
        if (searchData.endTimeRange && searchData.endTimeRange.length > 0) {
          [this.searchParams.endTimeFrom, this.searchParams.endTimeTo] = searchData.endTimeRange;
        }
        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        console.log('清空查询', form);
        this.searchParams = {
          orderId: null,
          userId: null,
          oldPlatformOrderId: null,
          merchantId: null,
          merchantName: null,
          orderType: null,
          tradeMode: null,
          payMethod: null,
          paymentStatus: null,
          sourceChannel: null,
          orderMethod: null,
          orderStatus: null,
          startTimeRange: [],
          endTimeRange: [],
          startTimeFrom: null,
          startTimeTo: null,
          endTimeFrom: null,
          endTimeTo: null,
        };

        // 近30天初始化时间
        const startDate = getLastTime('yyyy-MM-dd', 30);
        const endDate = getLastTime('yyyy-MM-dd', 0);

        this.searchParams.startTimeRange = [startDate, endDate];
        this.searchParams.startTimeFrom = startDate;
        this.searchParams.startTimeTo = endDate;
      },
      /**
       * 分页器页数
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       * 分页器条数
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
      /**
       * 请求列表数据
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        businessPlatform
          .getOrderDataList(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 抽屉关闭回调
       */
      onAddDrawerClose(done) {
        done();
      },
      /**
       * 获取下单方式文本
       */
      getOrderMethodText(orderMethod) {
        if (orderMethod === undefined || orderMethod === null) {
          return '——';
        }

        const orderMethodMap = {
          1: '扫码启动',
          2: '扫码启动',
          3: '刷卡启动',
          4: '即插即充',
          5: '流量方',
          6: '预约充电',
          7: '离线卡',
          8: '私桩即插即充',
          9: '私桩预约充电',
        };

        return orderMethodMap[orderMethod] || orderMethod; // 如果下单方式码不在映射中，返回原始值
      },

      /**
       * 获取支付状态文本
       */
      getPaymentStatusText(paymentStatus) {
        if (paymentStatus === undefined || paymentStatus === null) {
          return '——';
        }

        const paymentStatusMap = {
          1: '待支付',
          2: '支付成功',
          3: '支付失败',
          4: '已退款',
        };

        return paymentStatusMap[paymentStatus] || paymentStatus; // 如果支付状态码不在映射中，返回原始值
      },

      /**
       * 获取支付方式文本
       */
      getPayMethodText(payMethod) {
        if (payMethod === undefined || payMethod === null) {
          return '——';
        }

        const payMethodMap = {
          0: '个人',
          1: '企业',
          2: '微信支付分',
          3: '支付宝芝麻信用',
          4: '微信',
          5: '支付宝',
          6: '会员权益卡',
        };

        return payMethodMap[payMethod] || payMethod; // 如果支付方式码不在映射中，返回原始值
      },

      /**
       * 获取交易模式文本
       */
      getTradeModeText(tradeMode) {
        if (tradeMode === undefined || tradeMode === null) {
          return '——';
        }

        const tradeModeMap = {
          1: '自营',
          2: '加盟',
        };

        return tradeModeMap[tradeMode] || tradeMode; // 如果类型码不在映射中，返回原始值
      },

      /**
       * 处理数据
       */
      dealData(value) {
        if (value !== undefined && value !== null && value !== '') {
          return value;
        }
        return '——';
      },

      /**
       * 获取用户等级文本
       */
      getUserLevelText(userLevel) {
        if (userLevel === undefined || userLevel === null) {
          return '——';
        }

        const userLevelMap = {
          1: '青铜会员',
          2: '白银会员',
          3: '黄金会员',
          4: '铂金会员',
          5: '星耀会员',
        };

        return userLevelMap[userLevel] || userLevel; // 如果用户等级码不在映射中，返回原始值
      },
      /**
       * 获取ai分析结果：提交异步任务后轮询结果，避免AI长耗时导致网关超时（504）
       */
      getAiResult(tradeSeq) {
        this.loading = true;
        this.aiData = {};
        orderPage
          .orderDiagnosis({ tradeSeq })
          .then(res => {
            const taskId = res && res.taskId;
            if (!taskId) {
              this.$message.error('AI诊断任务提交失败，请稍后重试');
              this.loading = false;
              return;
            }
            this.pollAiResult(taskId, 0);
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
          });
      },
      /**
       * 轮询AI诊断任务结果：每3秒一次，最多60次（约3分钟）
       */
      pollAiResult(taskId, times) {
        if (times >= 60) {
          this.$message.error('AI诊断超时，请稍后重试');
          this.loading = false;
          return;
        }
        setTimeout(() => {
          orderPage
            .orderDiagnosisResult({ taskId })
            .then(res => {
              const status = res && res.status;
              if (status === 1) {
                this.aiData = (res && res.result) || {};
                this.loading = false;
              } else if (status === 2) {
                this.$message.error((res && res.errorMsg) || 'AI诊断失败，请稍后重试');
                this.loading = false;
              } else {
                this.pollAiResult(taskId, times + 1);
              }
            })
            .catch(err => {
              // 网络抖动等异常不中断轮询，继续尝试直到达到次数上限
              console.log(err);
              this.pollAiResult(taskId, times + 1);
            });
        }, 3000);
      },

      /**
       * 获取订单类型文本
       */
      getOrderTypeText(orderType) {
        if (orderType === undefined || orderType === null) {
          return '——';
        }

        const orderTypeMap = {
          1: '淘淘充充电订单',
          2: '益虫充电订单',
        };

        return orderTypeMap[orderType] || orderType; // 如果订单类型码不在映射中，返回原始值
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ykc-checkbox .icon-check {
    top: 7px;
  }

  .directConnectionPile-list {
    .ykc-table {
      .el-table .el-table__row {
        .cell .userStatus {
          padding-left: 8px;
          position: relative;
        }
        .cell .userStatus::after {
          display: block;
          content: '';
          width: 5px;
          height: 5px;
          border-radius: 100%;
          background: #d0021b;
          position: absolute;
          top: 5.5px;
          left: 0;
        }
        .cell .status-red {
          color: #d0021b;
        }

        .cell .status-blue::after {
          background: #4d8cfd;
        }

        .cell .status-green::after {
          background: #02c498;
        }

        .cell .status-black::after {
          background: #9b9b9b;
        }
      }

      .sealBtn {
        color: #4d8cfd;
        cursor: pointer;
      }
    }
  }

  .status-wrap {
    display: flex;
    align-items: center;
  }

  .status-tip {
    margin-left: 10px;
    color: #fff !important;
    padding: 3px 7px;
    border-radius: 12px;
  }

  .status-info-tip {
    background-color: green;
  }

  .status-err-tip {
    background-color: red;
  }

  .drawer-main-body {
    padding: 10px 20px;
  }

  ::v-deep.ykc-checkbox .icon-check {
    top: 8px;
  }

  ::v-deep.customForm .el-form-item,
  ::v-deep.customForm .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
</style>
